import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      props: {
        multiple: true,
        showing: {
          type: Boolean,
          default: false
        }
      },
      dialogFormVisible: false,
      formData: {
        id: ""
      },
      appListAllList: []
    };
  },
  mounted: function mounted() {},
  created: function created() {},
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.formData.id = row.id;

                _this.$api.appListAllDataNoAuth().then(function (res) {
                  if (res.status == 200) {
                    _this.$api.authAppList({
                      enterprise_id: row.id
                    }).then(function (resq) {
                      if (resq.status == 200) {
                        res.data.map(function (i) {
                          i.Selection = resq.data.findIndex(function (j) {
                            return j.appid == i.appid;
                          }) > -1 ? true : false;
                        });
                        _this.appListAllList = res.data;
                      }
                    });
                  }
                });

                _this.copyData();

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data, newArr;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = JSON.parse(JSON.stringify(_this2.formData));
                newArr = [];

                _this2.appListAllList.map(function (i) {
                  if (i.Selection) {
                    newArr.push(i.appid);
                  }
                });

                _this2.$api.enterpriseAppSave({
                  id: _this2.formData.id,
                  appids: newArr
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.$message.success("设置成功");

                    _this2.dialogFormVisible = false;
                  }
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};